import { AccountRoutes } from '@webapp/account/src/resources/routes';

import { Modal } from '@webapp/common/components/modal';

import css from './expired-modal.css';

export const ExpiredModal: FC = () => (
    <Modal className={css.modal} closeBtn={false} title='Лицензия истекла' visible={true}>
        <a className={css.logout} href={AccountRoutes.authLogout.link}>
            Выход
        </a>
        Для продолжения работы необходимо оплатить доступ к сервису.
        <br />
        Если у вас возникли вопросы, обратитесь в поддержку.
    </Modal>
);
